import React, { useState, useContext } from 'react'
import classNames from 'classnames'
import { bool, string } from 'prop-types'
import Icon from 'components/uiElements/Icon'

import SugarcubeContext from 'apps/SugarcubeContext'

require('./ProductItemImage.scss')

const ProductItemImage = ({ thumbUrl, name, showIcon, isInSwap }) => {
    const [imgIsLoading, setImgIsLoading] = useState(true)

    const { isMobile } = useContext(SugarcubeContext)

    return (
        <div className="imageContainer">
            {showIcon && (
                <div className={classNames('imgOverlay', { isInSwap, mobile: isMobile })}>
                    <div className="ctaIcon">
                        <Icon code={isInSwap ? 'ap_swap' : 'plus'} svg />
                    </div>
                </div>
            )}

            <img
                src={`${thumbUrl}?f=u`}
                alt={name}
                className={classNames('thumbImage', { noIcon: !showIcon, imgIsLoading, isInSwap, mobile: isMobile })}
                onLoad={() => setImgIsLoading(false)}
            />
        </div>
    )
}

ProductItemImage.defaultProps = {
    isInSwap: false,
    showIcon: false,
}
ProductItemImage.propTypes = {
    thumbUrl: string.isRequired,
    name: string.isRequired,
    showIcon: bool,
    isInSwap: bool,
}

export default ProductItemImage
